import React from 'react';
import { motion } from 'framer-motion';
import { User, Briefcase, Rocket } from 'lucide-react';
import { Card, CardContent } from "@/components/ui/card";

const Slide6BusinessModel = () => {
    return (
        <div className="w-full h-full bg-background p-8 lg:p-16 flex flex-col justify-center relative">
            {/* Background Grid Texture */}
            <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
                style={{ backgroundImage: 'linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)', backgroundSize: '40px 40px' }}
            />
            <div className="max-w-6xl mx-auto w-full">
                <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    className="mb-12"
                >
                    <h2 className="text-4xl lg:text-6xl font-bold mb-4">India’s Emerging <span className="text-primary">Wealth Creators</span></h2>
                    <div className="flex gap-4 text-xl text-muted-foreground">
                        <span>Young Professionals</span>
                        <span>•</span>
                        <span>Freelancers</span>
                        <span>•</span>
                        <span>Small and Medium-Sized Business Owners</span>
                    </div>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {[
                        { title: "The Young Professionals", icon: User, income: "₹50k - ₹1L/mo", trait: "Active UPI User", need: "Needs structure, lacks time." },
                        { title: "The Freelancer", icon: Rocket, income: "Variable", trait: "Multiple Income Streams", need: "Needs stability & tax planning." },
                        { title: "The SMB Owner", icon: Briefcase, income: "₹5L - ₹10L/mo", trait: "Large Cash Flow", need: "Needs growth beyond FD." }
                    ].map((persona, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.1 + 0.2 }}
                        >
                            <Card className="bg-card border-border hover:border-primary transition-colors h-full group">
                                <CardContent className="p-6 flex flex-col items-center text-center pt-10">
                                    <div className="w-20 h-20 rounded-full bg-secondary flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors">
                                        <persona.icon className="w-10 h-10 text-muted-foreground group-hover:text-primary transition-colors" />
                                    </div>
                                    <h3 className="text-2xl font-bold mb-2 text-foreground">{persona.title}</h3>
                                    <p className="text-primary font-mono mb-4">{persona.income}</p>
                                    <div className="space-y-2 text-sm text-muted-foreground">
                                        <p className="border-b border-border pb-2">"{persona.trait}"</p>
                                        <p className="font-medium text-foreground">"{persona.need}"</p>
                                    </div>
                                </CardContent>
                            </Card>
                        </motion.div>
                    ))}
                </div>

                <div className="mt-12 text-center">
                    <p className="text-lg text-muted-foreground">Shared Pain: <span className="text-white font-semibold">Lack of structured guidance. Need an "Always-on AI CFO".</span></p>
                </div>
            </div>
        </div>
    );
};

export default Slide6BusinessModel;